<div class="TotemProfile">
    <div class="card">
        <div class="card-body text-center">
            <div class="TotemProfile-Avatar text-white rounded-circle mx-auto" aria-hidden="true">
                <i class="fa fa-user"></i>
            </div>
            <div class="mt-3">
                <h2 class="m-0 h4">{{ userName || ('totem-footer.button-profile' | locTranslate) }}</h2>
                @if (userEmail) {
                    <div class="text-muted">{{ userEmail }}</div>
                }
            </div>
        </div>
    </div>

    <div class="card mt-3">
        <div class="card-body text-center">
            <div class="mb-3" aria-hidden="true">
                <i class="fa-regular fa-trophy fa-2x text-primary"></i>
            </div>
            <h3 class="m-0 h5">{{ 'totem-profile.level-title' | locTranslate }}</h3>
            <div class="text-muted">{{ 'totem-profile.level-description' | locTranslate:'num':6 }}</div>
            <div class="progress my-2" role="progressbar" [attr.aria-valuenow]="75" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="'totem-profile.level-title' | locTranslate">
                <div class="progress-bar bg-primary w-100" [style.transform]="'translate(-25%,0)'"></div>
            </div>
            <div class="text-muted small">{{ 'totem-profile.level-missing' | locTranslate:'num':2 }}</div>
        </div>
    </div>

    <ng-content></ng-content>

    <nav class="d-flex flex-wrap justify-content-around gap-2 pt-2 border-top mt-3" [attr.aria-label]="'totem-a11y.opens-new-window' | locTranslate">
        <a target="_blank" rel="noopener noreferrer" [href]="privacyPolicyURL">
            {{ 'pg-footer.privacy-policy' | locTranslate }}
            <span class="visually-hidden"> {{ 'totem-a11y.opens-new-window' | locTranslate }}</span>
        </a>
        <a target="_blank" rel="noopener noreferrer" [href]="termsAndConditionsURL">
            {{ 'pg-footer.terms-and-conditions' | locTranslate }}
            <span class="visually-hidden"> {{ 'totem-a11y.opens-new-window' | locTranslate }}</span>
        </a>
        @if (isCookieConsentAvailable()) {
            <a href="javascript:void(0)" (click)="reviewCookies()">
                {{ 'pg-footer.review-cookies' | locTranslate }}
            </a>
        }
    </nav>
</div>
